import { useSessionStore } from '@/entities/session';
import { formatScore } from '@/shared/lib';

import styles from './AppHeader.module.scss';

/** Хэдер мини-аппа (узел 374:3342). Общий для всех экранов, не текст заголовка. */
export function AppHeader() {
  const funcoinBalance = useSessionStore((state) => state.funcoinBalance);
  const weeklyPoints = useSessionStore((state) => state.weeklyPoints);
  const freebetsEarned = useSessionStore((state) => state.freebetsEarned);

  return (
    <header className={styles.root} data-testid="app-header">
      <img
        className={styles.logo}
        src="/images/header/logo-tag.svg"
        alt="BetBoom"
      />

      <div className={styles.counters}>
        <span className={styles.counter} data-testid="predict-coin-counter">
          <img
            className={styles.icon}
            src="/images/header/predict-coin.svg"
            alt=""
            aria-hidden
          />
          {formatScore(funcoinBalance)}
        </span>
        {/* Огонь означает Очки — так во всём приложении (карточка игрока,
            «Топ 10», Ачивки). В ките счётчик подписан как стрик, но это
            ошибка кита: заказчик подтвердил 24.08.2026, что здесь Очки. */}
        <span className={styles.counter} data-testid="weekly-points-counter">
          <img
            className={styles.icon}
            src="/images/header/fire.svg"
            alt=""
            aria-hidden
          />
          {formatScore(weeklyPoints)}
        </span>
        <span className={styles.counter} data-testid="freebet-counter">
          <img
            className={styles.freebetIcon}
            src="/images/header/freebet.svg"
            alt=""
            aria-hidden
          />
          {formatScore(freebetsEarned)}
        </span>
      </div>
    </header>
  );
}
